module.exports = __webpack_public_path__ + "static/media/header_slide_10.20f7fe6c.jpg";